import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('messageSettings', app)

  store.getters.listByName = function (state) {
    const settingsByName = {}
    state.list.default.data.forEach((s) => {
      settingsByName[s['name']] = s
    })

    return settingsByName
  }
  return store
}
